import React, { useState, useContext, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom"; 
import AppContext from "../../../../context/AppContext";
import { Eye, EyeOff } from 'lucide-react';
import "../../../../assets/css/customer/publicCustomerCss/CustomerFormCss/customerLoginForm.css";

  const CustomerLoginForm = () => {  
  const { baseUrl, validateField, setAuthToken,setHotelId ,setVendorId} = useContext(AppContext); 
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");  
  const [password, setPassword] = useState("");  
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState("tourist");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [emailError, setEmailError] = useState("");  
  const [passwordError, setPasswordError] = useState("");  

const checkVendor = (vendorId) => {
  const token = localStorage.getItem("authToken");  
  
  axios.get(`${baseUrl}/vendor/check-vendor/${vendorId}`, {
    headers: { 
      "Authorization": `Bearer ${token}`  
    }
  })
  .then((response) => {
    if (response.data.success && response.data.has_hotel) {
      setMessage("Welcome back! Redirecting to dashboard...");
      setMessageType("success");
      setTimeout(() => navigate("/vendor/hotel-dashboard"), 800);
    } else {
      setMessage("Please register your hotel first! Redirecting...");
      setMessageType("success");
      setTimeout(() => navigate("/vendor/settings/hotel-settings"), 800);
    }
  })
  .catch(() => {
    setTimeout(() => navigate("/vendor/settings/hotel-settings"), 800);
  });
};

  const handleVendorLogin = (email, password) => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios.post(`${baseUrl}/vendor/login`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {
      if (response.data.success) {
        const vendorId = response.data.vendor.id;
        
        localStorage.setItem("vendorEmail", email);
        localStorage.setItem("vendorPassword", password);
        localStorage.setItem("userRole", "vendor");
        localStorage.setItem("vendorId", vendorId);
        localStorage.setItem("userName", response.data.vendor.name);
         localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("hotelId", response.data.vendorhotel.id);
        setAuthToken(response.data.token);

        setMessage("Login successful! Checking hotel status...");
        setMessageType("success");
        checkVendor(vendorId);
        setVendorId(vendorId);

        setHotelId(response.data.vendorhotel.id);
  
      } else {
        setMessage(response.data.message || "Invalid credentials");
        setMessageType("error");
        setLoading(false);
        setPageLoading(false);
      }
    })
    .catch((error) => {
      setMessage(error.response?.data?.message || "Login failed");
      setMessageType("error");
      setLoading(false);
      setPageLoading(false);
    });
  };

  const handleCustomerLogin = (email, password) => {
    const formData = new FormData();
    formData.append("cus_email", email);
    formData.append("cus_password", password);

    axios.post(`${baseUrl}/customer/login`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {
      if (response.data.success) {
        const customer = response.data.customer;
        
        localStorage.setItem("customerEmail", email);
        localStorage.setItem("customerPassword", password);
        localStorage.setItem("userRole", "customer");
        localStorage.setItem("customerId", customer.id);
        localStorage.setItem("userName", customer.cus_username);
        localStorage.setItem("authToken", response.data.token);
        setAuthToken(response.data.token);
        setMessage("Login successful! Redirecting...");
        setMessageType("success");


setTimeout(()=>{


    const pendingPackage =
        localStorage.getItem(
            "pendingBookingPackage"
        );


    if(pendingPackage){


        localStorage.removeItem(
            "pendingBookingPackage"
        );


        navigate(
            `/packages/${pendingPackage}?bookPackage=${pendingPackage}`
        );


    }
    else{


        navigate("/customer/dashboard");


    }


},800);
      } else {
        setMessage(response.data.message || "Invalid credentials");
        setMessageType("error");
        setLoading(false);
        setPageLoading(false);
      }
    })
    .catch((error) => {
      setMessage(error.response?.data?.message || "Login failed");
      setMessageType("error");
      setLoading(false);
      setPageLoading(false);
    });
  };

 const vendorAutoLogin = (email, password) => {
    setPageLoading(true);
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios.post(`${baseUrl}/vendor/login`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {
      if(response.data.success) {
        const vendorId = response.data.vendor.id;
        localStorage.setItem("authToken", response.data.token);  
        setAuthToken(response.data.token);
        checkVendor(vendorId);   
         setVendorId(vendorId);

        setHotelId(response.data.vendorhotel.id);
                                  
      } else {
        setPageLoading(false);
      }
    })
    .catch((error) => {
      console.error("Auto-login error:", error);
      setPageLoading(false);
    });
};

  const customerAutoLogin = (email, password) => {
    setPageLoading(true);
    const formData = new FormData();
    formData.append("cus_email", email);
    formData.append("cus_password", password);

    axios.post(`${baseUrl}/customer/login`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {
      if(response.data.success) {
        const customer = response.data.customer;
        localStorage.setItem("customerEmail", email);
        localStorage.setItem("customerPassword", password);
        localStorage.setItem("userRole", "customer");
        localStorage.setItem("customerId", customer.id);
        localStorage.setItem("userName", customer.cus_username);
        localStorage.setItem("authToken", response.data.token); 
        setAuthToken(response.data.token);
       setTimeout(()=>{


    const pendingPackage =
        localStorage.getItem(
            "pendingBookingPackage"
        );


    if(pendingPackage){

        localStorage.removeItem(
            "pendingBookingPackage"
        );


        navigate(
          `/packages/${pendingPackage}?bookPackage=${pendingPackage}`
        );


    }
    else{

        navigate("/customer/dashboard");

    }


},800);
      } else {
        setPageLoading(false);
      }
    })
    .catch((error) => {
      console.error("Customer auto-login error:", error);
      setPageLoading(false);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailErr = validateField('email', email);
    const passwordErr = validateField('required', password);
    
    setEmailError(emailErr);
    setPasswordError(passwordErr);

    if (emailErr || passwordErr) {
      setMessage("Please fix the errors above.");
      setMessageType("error");
      return;
    }

    setLoading(true);
    setMessage("Logging in...");
    setMessageType("success");

    if (role === 'vendor') {
      handleVendorLogin(email, password);
    } 
    else if (role === 'tourist') {
      handleCustomerLogin(email, password);
    }
  };
useEffect(() => {
    setPageLoading(true);
    const storedRole = localStorage.getItem("userRole");
    
    const storedVendorEmail = localStorage.getItem("vendorEmail");
    const storedVendorPassword = localStorage.getItem("vendorPassword");
    
    const storedCustomerEmail = localStorage.getItem("customerEmail");
    const storedCustomerPassword = localStorage.getItem("customerPassword");

    if(storedRole === 'vendor' && storedVendorEmail && storedVendorPassword) {
      vendorAutoLogin(storedVendorEmail, storedVendorPassword);
    } 
    else if(storedRole === 'customer' && storedCustomerEmail && storedCustomerPassword) {
      customerAutoLogin(storedCustomerEmail, storedCustomerPassword);
    }
    else {
      setPageLoading(false);
    }
}, [location.pathname]);

  if (pageLoading) {
    return (
      <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center">
        <div className="spinner-border text-warning" style={{width: "3rem", height: "3rem"}} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Form id="ta-loginForm" className="ta-login-form" onSubmit={handleSubmit}>
      <h2 className="ta-form-title">Welcome Back</h2>

      {message && <p className={`ta-message ta-${messageType}`}>{message}</p>}

      <Form.Group controlId="loginEmail" className="ta-form-group">
        <input
          type="email"
          name="email"
          className={`ta-form-control ${emailError ? 'is-invalid' : ''}`}
          placeholder="Email address"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setEmailError('');
          }}
          disabled={loading}
          required
        />
        {emailError && <div className="invalid-feedback">{emailError}</div>}
      </Form.Group>

      <Form.Group controlId="loginPassword" className="ta-form-group">
        <div className="ta-password-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            className={`ta-password-input ${passwordError ? 'is-invalid' : ''}`}
            placeholder="Password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              setPasswordError('');
            }}
            disabled={loading}
            required
          />
          <button 
            type="button"
            className="ta-eye-btn"
            onClick={() => setShowPassword(!showPassword)}
            disabled={loading}
          >
            {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
          </button>
        </div>
        {passwordError && <div className="invalid-feedback">{passwordError}</div>}
      </Form.Group>

      <Form.Group controlId="loginRole" className="ta-form-group">
        <Form.Select
          className="ta-form-control"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          disabled={loading}
        >
          <option value="tourist">Tourist</option>
          <option value="vendor">Vendor</option>
        </Form.Select>
      </Form.Group>

      <Button type="submit" className="ta-submit-btn" disabled={loading}>
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Logging in...
          </>
        ) : (
          "Login"
        )}
      </Button>
    </Form>
  );
};

export default CustomerLoginForm;